module.exports = __webpack_public_path__ + "img/ai.bc6b0079.svg";